export default __webpack_public_path__ + "static/media/32t.b8ce4acd.jpg";